import { render, staticRenderFns } from "./DiaForm.vue?vue&type=template&id=620ec915&scoped=true&"
import script from "./DiaForm.vue?vue&type=script&lang=js&"
export * from "./DiaForm.vue?vue&type=script&lang=js&"
import style0 from "./DiaForm.vue?vue&type=style&index=0&id=620ec915&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "620ec915",
  null
  
)

export default component.exports